(function () {
  'use strict';

  if (window.UnifiedDebug) {
    return;
  }

  const VERSION = '1.0.0';
  const EVENT_NAME = 'unified:debug';
  const MAX_HISTORY = 200;

  const history = [];

  function clone(value) {
    try {
      return JSON.parse(
        JSON.stringify(value)
      );
    } catch (error) {
      return value;
    }
  }

  function normalizeEntry(
    detail
  ) {
    const source =
      detail || {};

    return {
      type:
        source.type ||
        'unknown',

      timestamp:
        source.timestamp ||
        new Date()
          .toISOString(),

      data:
        clone(
          source.data ||
          {}
        )
    };
  }

  function record(
    detail
  ) {
    const entry =
      normalizeEntry(
        detail
      );

    history.push(
      entry
    );

    if (
      history.length >
      MAX_HISTORY
    ) {
      history.splice(
        0,
        history.length -
          MAX_HISTORY
      );
    }

    if (
      window.UnifiedTrackingConfig &&
      window.UnifiedTrackingConfig
        .debug === true
    ) {
      const eventName =
        entry.data &&
        entry.data.event
          ? entry.data.event
          : '';

      console.info(
        '[Unified Debug]',
        new Date(
          entry.timestamp
        ).toLocaleTimeString(),
        '·',
        entry.type,
        eventName
          ? '· ' + eventName
          : ''
      );
    }

    return entry;
  }

  function getHistory() {
    return clone(
      history
    );
  }

  function printHistory() {
    console.table(
      history.map(
        function (
          entry,
          index
        ) {
          return {
            index:
              index + 1,

            timestamp:
              entry.timestamp,

            type:
              entry.type,

            event:
              entry.data &&
              entry.data.event
                ? entry.data.event
                : ''
          };
        }
      )
    );

    return getHistory();
  }

  function clearHistory() {
    history.length = 0;

    console.info(
      '[Unified Debug] History cleared.'
    );

    return true;
  }

  function findByType(
    type
  ) {
    return getHistory()
      .filter(
        function (
          entry
        ) {
          return (
            entry.type ===
            type
          );
        }
      );
  }

  function findByEvent(
    eventName
  ) {
    return getHistory()
      .filter(
        function (
          entry
        ) {
          return (
            entry.data &&
            entry.data.event ===
              eventName
          );
        }
      );
  }

  window.addEventListener(
    EVENT_NAME,
    function (
      event
    ) {
      record(
        event.detail ||
        {}
      );
    }
  );

  window.UnifiedDebug = {
    version:
      VERSION,

    getHistory:
      getHistory,

    printHistory:
      printHistory,

    clearHistory:
      clearHistory,

    findByType:
      findByType,

    findByEvent:
      findByEvent
  };
})();